import { Link } from 'react-router-dom';

const features = [
  {
    label: 'A quiet, private space for family memories',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
        <circle cx="12" cy="13" r="4"/>
      </svg>
    ),
  },
  {
    label: 'Invite-only sharing with the people who matter most',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
      </svg>
    ),
  },
  {
    label: 'Record voices before they fade with time',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
        <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
        <line x1="12" y1="19" x2="12" y2="23"/>
        <line x1="8" y1="23" x2="16" y2="23"/>
      </svg>
    ),
  },
  {
    label: 'Keep everyday stories alongside life\'s biggest milestones',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
        <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
      </svg>
    ),
  },
  {
    label: 'Turn everyday moments into lasting family memories',
    icon: (
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
      </svg>
    ),
  },
];

export function AuthHero() {
  return (
    <div className="bg-gradient-to-br from-indigo-600 via-indigo-700 to-indigo-900 text-white p-5 sm:p-8 desktop:flex-1 desktop:flex desktop:flex-col desktop:justify-center desktop:p-14">
      {/* Logo — only thing shown on phones; full hero content is desktop-only */}
      <Link to="/about" className="inline-flex items-center gap-2.5 mb-0 lg:mb-10 group w-fit">
        <div className="w-9 h-9 rounded-xl bg-white/20 flex items-center justify-center flex-shrink-0 group-hover:bg-white/30 transition-colors">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2">
            <circle cx="12" cy="12" r="3"/>
            <path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"/>
          </svg>
        </div>
        <span className="text-lg font-bold font-serif tracking-tight">EventsCarousel</span>
      </Link>

      <div className="hidden desktop:block">
        {/* Headline — primary SEO h1 */}
        <h1 className="text-[2.4rem] font-serif font-bold leading-tight mb-3 mt-10 max-w-md">
          A private home for the moments your family wants to cherish forever.
        </h1>
        <p className="text-indigo-200 text-base leading-relaxed mb-10 max-w-md">
          EventsCarousel helps you preserve photos, voices, and stories in one private place for generations to come — so the people you love, and the memories that shape them, are never lost in the noise.
        </p>

        {/* Feature list */}
        <div className="grid grid-cols-1 gap-4 mb-10">
          {features.map(f => (
            <div key={f.label} className="flex items-start gap-2.5">
              <div className="w-6 h-6 rounded-md bg-white/15 flex items-center justify-center flex-shrink-0 mt-0.5">
                {f.icon}
              </div>
              <span className="text-indigo-100 text-sm leading-snug">{f.label}</span>
            </div>
          ))}
        </div>

        {/* Quote from the About page */}
        <blockquote className="border-l-2 border-white/30 pl-4 text-indigo-300 text-sm italic leading-relaxed">
          "How we long to hear again the voice of a grandparent telling their story — of immigration, of struggle, of love. Those voices are worth preserving."
        </blockquote>
      </div>
    </div>
  );
}
